const collapse = () => {
  let collapseParent = document.querySelectorAll(
    ".course-program .collapse--content"
  );
  let collapseButton = document.querySelectorAll(
    ".course-program .collapse-btn"
  );
  let collapseHeader = document.querySelectorAll(
    ".course-program-container__title"
  );

  collapseHeader.forEach(function (el) {
    const button = el.querySelector(".collapse-btn");
    if (el.parentElement.querySelector(".collapse--content") && button) {
      el.style.cursor = "pointer";
      el.addEventListener("click", function () {
        button.click();
      });
    }
  });
  collapseButton.forEach(function (b, i) {
    let height = getContentHeight(collapseParent[i]);
    let isCollapsed = false;
    b.parentElement.nextElementSibling.style.height = isCollapsed
      ? height + "px"
      : 0;
    window.addEventListener("resize", function () {
      b.parentElement.nextElementSibling.style.height = isCollapsed
        ? getContentHeight(collapseParent[i]) + "px"
        : 0;
    });
    b.onclick = function (e) {
      height = getContentHeight(collapseParent[i]);
      e.stopPropagation();
      isCollapsed = !isCollapsed;
      e.target.parentElement.nextElementSibling.classList.toggle("collapsed");
      e.target.parentElement.nextElementSibling.style.height = isCollapsed
        ? getContentHeight(collapseParent[i]) + "px"
        : 0;
      e.target.classList.toggle("rotate");
    };
  });

  /* Определение высоты элемента */
  function getContentHeight(el) {
    var sum = 0;
    el.childNodes.forEach(function (child) {
      sum += child.scrollHeight || 0;
    });
    return sum;
  }
};

export default collapse;
